(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucine-gift-filter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseGiftFinder = (section) => {
      if (!section || section.dataset.giftFinderInitialised === 'true') return;

      const activateMode = (mode) => {
        section.querySelectorAll('[data-gift-mode]').forEach((tab) => {
          const active = tab.dataset.giftMode === mode;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });
        section.querySelectorAll('[data-gift-mode-panel]').forEach((panel) => {
          const active = panel.dataset.giftModePanel === mode;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      const activateMonth = (month) => {
        section.querySelectorAll('[data-gift-month]').forEach((tab) => {
          const active = tab.dataset.giftMonth === month;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });
        section.querySelectorAll('[data-gift-month-panel]').forEach((panel) => {
          const active = panel.dataset.giftMonthPanel === month;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      section.querySelectorAll('[data-gift-mode]').forEach((tab) => tab.addEventListener('click', () => activateMode(tab.dataset.giftMode)));
      section.querySelectorAll('[data-gift-month]').forEach((tab) => tab.addEventListener('click', () => activateMonth(tab.dataset.giftMonth)));
      section.dataset.giftFinderInitialised = 'true';
    };

    document.querySelectorAll('[data-gift-finder]').forEach(initialiseGiftFinder);
    document.addEventListener('shopify:section:load', (event) => initialiseGiftFinder(event.target.querySelector('[data-gift-finder]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucine-gift-refine"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseGiftRefine = (section) => {
      if (!section || section.dataset.giftRefineInitialised === 'true') return;
      const form = section.querySelector('[data-gift-refine-form]');
      const category = section.querySelector('[data-gift-refine-category]');
      const birthstone = section.querySelector('[data-gift-refine-birthstone]');
      const price = section.querySelector('[data-gift-refine-price]');
      const message = section.querySelector('[data-gift-refine-message]');

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!category.value && !birthstone.value && !price.value) {
          message.textContent = 'ひとつ以上の条件をお選びください。';
          category.focus();
          return;
        }

        const destination = new URL(category.value || '/collections/all', window.location.origin);
        if (birthstone.value) destination.searchParams.set('filter.p.m.custom.birthstone_month', birthstone.value);
        const values = price.value.split('|');
        if (values[0]) destination.searchParams.set('filter.v.price.gte', values[0]);
        if (values[1]) destination.searchParams.set('filter.v.price.lte', values[1]);
        window.location.assign(destination.toString());
      });

      section.dataset.giftRefineInitialised = 'true';
    };

    document.querySelectorAll('[data-gift-refine]').forEach(initialiseGiftRefine);
    document.addEventListener('shopify:section:load', (event) => initialiseGiftRefine(event.target.querySelector('[data-gift-refine]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
